<template>
	<swiper
		:slidesPerView="3.5"
		:spaceBetween="10"
		:centeredSlides="false"
		:loop="entries.length > 3"
		:navigation="entries.length > 1"
		:keyboard="{ enabled: true }"
		:a11y="{ enabled: true, prevSlideMessage: 'Vorig artikel', nextSlideMessage: 'Volgend artikel' }"
		:breakpoints="breakpoints"
		:modules="modules"
		class="swiper"
		aria-label="Uitgelichte artikelen"
	>
	<swiper-slide v-for="entry in entries" :key="entry.id">
			<a class="story-link" :href="entry.url">
				<div class="image-container" :class="cardClass">
					<img :src="entry.image" alt="" class="uk-border-rounded" loading="lazy" decoding="async">
				</div>
				<div class="title-container">
					<h3 class="content-swiper__title uk-margin-small max-lines-3">{{ entry.title }}</h3>
				</div>
			</a>
		</swiper-slide>

	</swiper>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import { A11y, Keyboard, Navigation } from 'swiper/modules';

export default {
	components: {
		Swiper,
		SwiperSlide,
	},
	props: {
		entries: {
			type: Array,
			required: true,
		},
		cardClass: {
			type: String,
			default: ''
		},
		breakpoints: {
			type: Object,
			default: () => ({
				'10': {
					slidesPerView: 1.5,
					spaceBetween: 10,
				},				
				'320': {
					slidesPerView: 1.5,
					spaceBetween: 10,
				},
				'640': {
					slidesPerView: 2.5,
					spaceBetween: 15,
				},
				'768': {
					slidesPerView: 2.5,
					spaceBetween: 20,
				},
				'1024': {
					slidesPerView: 2.5,
					spaceBetween: 20,
				},
			}),
		},		
	},
	mounted() {
		this.$logger('app/components/content-swiper/mounted');	
	},
	setup() {
		return {
			modules: [A11y, Keyboard, Navigation],
		};
	},
};
</script>

<style scoped>

/* default */
.swiper-slide .content-swiper__title {
	font-size: 0.9rem;
	line-height: 1.22;
	margin-top: 10px;
}
.swiper-slide .story-link {
	display: block;
	color: inherit;
}

/* portrait 4:5  */
.swiper-slide .portrait-4-5 {
	aspect-ratio: 4 / 5;
	overflow: hidden;
	border-radius: 10px;
}	
.swiper-slide .portrait-4-5 img {
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover !important;
}

/* portrait 9:16 */
/* portrait 4:5  */
.swiper-slide .portrait-9-16 {
	aspect-ratio: 9 / 16;
	overflow: hidden;
	border-radius: 10px;
}	
.swiper-slide .portrait-9-16 img {
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover !important;
}

</style>
